import { createContext } from "react";
import type { User, UserRole } from "@/features/accounts/types/account.types";

export interface AuthContextValue {
  user: User | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  role: UserRole | null;
  isAdmin: boolean;
  isEmployee: boolean;
  isCustomer: boolean;
  isBusinessManager: boolean;
  isBusinessEmployee: boolean;
  isPersonal: boolean;
  isSuperUser: boolean;
  isHijacked: boolean;
  requirePasswordReset: boolean;
  fullName: string;
  initials: string;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
